import {useContext} from "react";
import {HomeContext} from "../../../context/homeContext";
import ThreadPortalItem from "../../common/ThreadPortalItem";

import { Swiper, SwiperSlide } from "swiper/react";
import {Navigation, Autoplay} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import LoadingContent from "../../common/LoadingContent";
import LoadingNoMoreContent from "../../common/LoadingNoMoreContent";

const RelatedSection = () => {
	const {relatedThreads, relatedThreadsLoading} = useContext(HomeContext);

	if (relatedThreads && relatedThreads.length > 0) {
		return (
			<div>
				<Swiper
					className="highlight-section-slide"
					modules={[Navigation, Autoplay]}
					autoplay={{
						delay: 2500,
						disableOnInteraction: false,
					}}
					spaceBetween={10}
					slidesPerView={2}
					navigation
					breakpoints={{
						801: {
							slidesPerView: 4,
						},
						1201: {
							slidesPerView: 6,
						},
						1401: {
							slidesPerView: 8,
						}
					}}
				>
					{relatedThreads.map((thread, index) => (
						<SwiperSlide key={index}>
							<ThreadPortalItem thread={thread} />
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		)
	} else {
		if (relatedThreadsLoading) {
			return <LoadingContent/>;
		} else {
			return <LoadingNoMoreContent />;
		}
	}
}

export default RelatedSection;